<template>
  <div class="fotoportada-container" ref="containerRef">
    <!-- Capa de oscurecimiento y drama en la parte INFERIOR -->
    <div ref="darkOverlayRef" class="dark-overlay"></div>

    <div class="overlay-content">
        <!-- 2. NOMBRE Y APELLIDO (ABAJO, CENTRO DE ATENCIÓN) -->
      <div ref="nombreRef" class="centered-text">
        <span class="nombre-principal"> Kately Violeta</span>
      </div>
      <!-- 1. MIS XV Y ADORNO (ARRIBA DEL NOMBRE) -->
      <div ref="misXvWrapperRef" class="mis-xv-wrapper">
        <span class="subtitulo-editorial"></span>
        <div ref="misXvTopRef" class="mis-xv-top">
          MIS XV
        </div>
      </div>

    
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'CoverComponent',
  setup() {
    const containerRef = ref(null)
    const nombreRef = ref(null)
    const misXvWrapperRef = ref(null)
    const misXvTopRef = ref(null)
    const darkOverlayRef = ref(null)
    let tl = null

    onMounted(async () => {
      await nextTick()

      // Configuración de aceleración máxima
      gsap.config({ force3D: true })

      tl = gsap.timeline({
        defaults: { ease: 'power2.out' }
      })

      // 1. Escena cinemática de entrada para el fondo (Efecto 'Slow Zoom')
      tl.fromTo(
        containerRef.value,
        { autoAlpha: 0, scale: 1.12 },
        { autoAlpha: 1, scale: 1, duration: 1.8, ease: 'power1.out' }
      )

      // 2. Entra la penumbra/gradiente inferior creando contraste mágico
      .fromTo(
        darkOverlayRef.value,
        { autoAlpha: 0, y: 30 },
        { autoAlpha: 1, y: 0, duration: 1.2, ease: 'sine.out' },
        '-=1.4'
      )

      // 3. Destello de "MIS XV" con entrada limpia
      .fromTo(
        misXvWrapperRef.value,
        { autoAlpha: 0, y: 25, scale: 0.9 },
        { autoAlpha: 1, y: 0, scale: 1, duration: 1.0 },
        '-=0.9'
      )

      // 4. Revelado del Nombre (Impacto visual con elevación suave)
      .fromTo(
        nombreRef.value,
        { autoAlpha: 0, y: 35, scale: 0.95 },
        { autoAlpha: 1, y: 0, scale: 1, duration: 1.2, ease: 'power3.out' },
        '-=0.7'
      )
    })

    onUnmounted(() => {
      if (tl) tl.kill()
    })

    return {
      containerRef,
      nombreRef,
      misXvWrapperRef,
      misXvTopRef,
      darkOverlayRef
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;500;600&family=Cormorant+Garamond:ital,wght@0,300;1,300&family=Pinyon+Script&display=swap');

.fotoportada-container {
  position: relative;
  width: 100%;
  height: 95vh;
  overflow: hidden;
  background-image: url('@/assets/1_web.webp');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  z-index: 1;
  will-change: transform, opacity;
  transform: translateZ(0);
}

/* Gradiente Máxico/Drama INFERIOR */
.dark-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 75%;
  pointer-events: none;
  background: linear-gradient(
    to top,
    rgba(10, 8, 15, 0.92) 0%,
    rgba(10, 8, 15, 0.6) 45%,
    rgba(10, 8, 15, 0.15) 75%,
    transparent 100%
  );
  z-index: 2;
  will-change: opacity, transform;
}

/* Distribución tipográfica anclada abajo estilo Portada de Revista / Póster */
.overlay-content {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 3;
  width: 100%;
  display: flex;
      margin-top:-190px !important;

  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  padding: 0 20px 48px 20px;
  box-sizing: border-box;
  gap: 6px;
  text-align: center;
}

/* 1. MIS XV Y DETALLES */
.mis-xv-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.subtitulo-editorial {
  font-family: 'Cinzel', serif;
  font-size: 10px;
  letter-spacing: 4px;
  color: rgba(255, 255, 255, 0.85);
  text-transform: uppercase;
}

.mis-xv-top {
  font-family: 'Cinzel', serif;
  font-size: 18px;
  letter-spacing: 6px;
  color: #f3e5ab; /* Tono dorado champagne sutil */
  text-transform: uppercase;
  text-shadow: 0 0 10px rgba(243, 229, 171, 0.3);
}

/* 2. NOMBRE PRINCIPAL (Protagonista) */
.centered-text {
  font-family: 'CynthiaJuneJF', 'Pinyon Script', cursive, serif;
  font-size: 68px;
  line-height: 1.05;

  color: #ffffff;
  /* Sombra multicapa limpia sin lag de blur dinámico */
  text-shadow: 
    0 2px 8px rgba(0, 0, 0, 0.8),
    0 0 25px rgba(212, 175, 55, 0.35);
  margin: 0;
  padding: 0;
  will-change: transform, opacity;
}

.nombre-principal {
  display: block;
  white-space: nowrap;
}

/* Ocultar elementos para evitar destellos antes de iniciar GSAP */
.fotoportada-container,
.dark-overlay,
.mis-xv-wrapper,
.centered-text {
  opacity: 0;
}
</style>